import { PathLocationStrategy } from "@angular/common";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class PathLocationStrategyWithoutHistoryState extends PathLocationStrategy {
    // override pushState( state: any, title: string, url: string, queryParams: string ): void {
    //     this.replaceState(state , title, url, queryParams)
    // }
  }
